import { render } from "./JourneyArrow.vue?vue&type=template&id=1a3da01a"
const script = {}
script.render = render

export default script